import React, { useState } from "react";
import { useCart } from "../../context/CartContext"; // Import the cart context
import { FaMinus, FaPlus } from "react-icons/fa"; // Import icons for quantity control

const Platter = ({ platter }) => {
  const { cart, setCart } = useCart(); // Access cart context
  const [selectedItems, setSelectedItems] = useState([]);

  // Add or remove items from the cart
  const handleCheckboxChange = (itemId) => {
    if (selectedItems.includes(itemId)) {
      // Remove item from cart
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
      setCart(cart.filter((item) => item._id !== itemId));
    } else {
      // Add item to cart
      const itemToAdd = platter.foodItems.find((item) => item._id === itemId);
      if (itemToAdd) {
        setSelectedItems([...selectedItems, itemId]);
        setCart([...cart, { ...itemToAdd, quantity: 1 }]); // Add item with initial quantity of 1
      }
    }
  };

  // Update quantity of an item in the cart
  const updateQuantity = (id, amount, replace = false) => {
    const updatedCart = cart.map((item) =>
      item._id === id
        ? {
            ...item,
            quantity: replace
              ? Math.max(1, amount) // Ensure quantity is at least 1
              : Math.max(1, item.quantity + amount), // Ensure quantity is at least 1
          }
        : item
    );
    setCart(updatedCart);
  };

  // Remove an item from the cart
  const removeItem = (id) => {
    const updatedCart = cart.filter((item) => item._id !== id);
    setCart(updatedCart);
    setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
  };

  if (!platter) return <div>Loading...</div>;

  return (
    <div className="flex flex-col items-center justify-center bg-white p-6 rounded-lg shadow-lg mt-8 w-full">
      <h1 className="text-3xl font-bold text-green-900 text-center mb-8">
        {platter.platterType}
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {platter.foodItems.map((item) => (
          <div
            key={item._id}
            className="bg-green-50 border border-green-200 rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow duration-300 w-auto h-auto flex justify-center"
          >
            <div className="flex items-center justify-center">
              <img
                src={item.imageUrl}
                alt={item.title}
                className="w-full h-40 object-fill rounded-lg"
              />
            </div>
            <div className="flex flex-col justify-center items-center pl-2">
              <div className="flex flex-col items-center justify-center flex-grow">
                <h2 className="text-[10px] md:text-[15px] lg:text-[20px] font-semibold text-green-800 truncate">
                  {item.title}
                </h2>
                <p className="text-gray-600 text-[8px] md:text-[10px] lg:text-[15px] line-clamp-2">
                  {item.desc}
                </p>
                <p className="text-green-600 font-bold mt-2">৳{item.price}</p>
              </div>

              {/* Quantity Controls */}
              {selectedItems.includes(item._id) ? (
                <div className="flex items-center justify-between mt-4">
                  <button
                    onClick={() => updateQuantity(item._id, -1)}
                    className="text-green-600 hover:text-green-700"
                  >
                    <FaMinus />
                  </button>
                  <input
                    type="number"
                    value={
                      cart.find((cartItem) => cartItem._id === item._id)
                        ?.quantity || 1
                    }
                    min="1"
                    onChange={(e) => {
                      let value = parseInt(e.target.value, 10);
                      if (isNaN(value) || value < 1) value = 1;
                      updateQuantity(item._id, value, true);
                    }}
                    className="w-12 text-center border border-green-200 rounded-lg"
                  />
                  <button
                    onClick={() => updateQuantity(item._id, 1)}
                    className="text-green-600 hover:text-green-700"
                  >
                    <FaPlus />
                  </button>
                </div>
              ) : (
                <label className="flex items-center mt-4">
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item._id)}
                    onChange={() => handleCheckboxChange(item._id)}
                    className="form-checkbox h-5 w-5 text-green-600 rounded "
                  />
                  <span className="ml-2 text-gray-700 text-[10px] md:text-[15px] lg:text-[20px] font-semibold">
                    Select
                  </span>
                </label>
              )}

              {/* Remove Button */}
              {selectedItems.includes(item._id) && (
                <button
                  onClick={() => removeItem(item._id)}
                  className="mt-2 text-[10px] md:text-[15px] lg:text-[20px] text-red-600 hover:text-red-700 border rounded p-1 bg-white font-semibold"
                >
                  Remove
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Platter;
